import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'dialogs-loading',
    templateUrl: './dialogs-loading.component.html',
    styleUrls: ['./dialogs-loading.component.scss']
})
export class DialogsLoadingComponent implements OnInit {
    constructor(
        public dialogLoading: MatDialogRef<DialogsLoadingComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
    }
}